import {Injectable} from '@angular/core';

/**
 * Translations for login.
 */
@Injectable()
export class LoginTranslationsService {
  public i18nErrorLoginBadCredentials: any = $localize`:@@general.alertMessage.loginBadCredentials:You have entered an invalid username or password. Please try again.`;
  public i18nErrorLoginBadToken: any = $localize`:@@general.alertMessage.loginBadToken:You have entered an invalid token. Please try again.`;
  public i18nErrorSessionExpired: any = $localize`:@@general.alertMessage.logoutSessionExpired:You have been logged out automatically. Please log in again.`;
  public i18nErrorNotLoggedIn: any = $localize`:@@general.alertMessage.notLoggedIn:You must first login in order to access this page`;
  public i18nErrorForbidden: any = $localize`:@@general.alertMessage.forbidden:You must replace the current password with a new one.`;
  public i18nSuccessPasswordChange: any = $localize`:@@general.alertMessage.passwordUpdated:You have successfully updated your password.`;
  public i18nErrorNoAccess: any = $localize`:@@general.alertMessage.errorNoAccess:You do not have permission to access this page.`;
  constructor() { }
}
